<block-ui>
    <div class="d-flex flex-row-reverse">
        <button type="button" class="btn btn-primary btn-sm btn-light shadow-sm" (click)="fillTemplate()">Llenar formato</button>
    </div>
    <form [formGroup]="TemplateTypeForm">
        <div class="row">
            <div class="form-group col">
                <label for="template_types">Formatos legales disponibles</label>
                <select class="form-control form-control-sm" id="template_types" formControlName="TemplateType">
                    <option hidden value="0">Seleccione un formato</option>
                    <option *ngFor="let TemplateType of TemplateTypes" [value]="TemplateType.Id">{{TemplateType.Name}}</option>
                </select>
            </div>
        </div>
    </form>
</block-ui>